import GrabbableWindow from './GrabbableWindow';
import DPR from './DPR.js'

export default class MainCanvas {
  constructor(dragCamera, imageDataManager, dragToolManager, background, cursorHighlighter, gridLarge, gridSmall) {
    this._dragCamera = dragCamera;
    this._imageDataManager = imageDataManager;
    this._dragToolManager = dragToolManager;
    this._background = background;
    this._cursorHighlighter = cursorHighlighter;
    this._gridLarge = gridLarge;
    this._gridSmall = gridSmall;
    this._elCanvas = document.querySelector('#mainCanvas');
    this._ctx = this._elCanvas.getContext('2d');
    this._drawCalled = false;
    this._draw = this._draw.bind(this);
    this._resizeListener = [];
    this._drawListener = [];

    window.addEventListener('resize', this.resize.bind(this));
  }
  get width() { return this._elCanvas.width; }
  get height() { return this._elCanvas.height; }
  get size() { return [this.width, this.height]; }
  resize() {
    const width = DPR.mul(document.body.clientWidth);
    const height = DPR.mul(window.innerHeight);
    this._elCanvas.width = width;
    this._elCanvas.height = height;
    this._elCanvas.style.transform = `scale(${DPR.div(1)})`;
    this._background.resize(width, height);
    this._cursorHighlighter.resize(width, height);
    this._dragCamera.setOuterLimit(width, height, this._imageDataManager.width, this._imageDataManager.height);
    GrabbableWindow.instances.forEach(ins => ins.correctPosition());
    this.requestDraw();

    const elLogo = document.querySelector('#logoSection .logo');
    elLogo.width = DPR.div(elLogo.naturalWidth * 2);
    elLogo.height = DPR.div(elLogo.naturalHeight * 2);
    document.querySelector('#communityButton').style.top = `calc(2 * var(--base-size) + ${elLogo.height}px)`;
  }
  requestDraw() {
    if(!this._drawCalled) {
      requestAnimationFrame(this._draw);
      this._drawCalled = true;
    }
  }
  _draw() {
    this._ctx.imageSmoothingEnabled = false;
    this._ctx.clearRect(0, 0, this.width, this.height);
    this._imageDataManager.draw(this._ctx, this._dragCamera);
    this._dragToolManager.draw(this._ctx);
    this._gridLarge.draw(this._ctx, this._dragCamera, this._imageDataManager);
    this._gridSmall.draw(this._ctx, this._dragCamera, this._imageDataManager);
    this._drawCalled = false;
  }
  changeCursor(cursor) {
    this._elCanvas.style.cursor = cursor;
  }
}
